const EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

const domainValidation = (email, domains) => {
  const emailDomain = email?.slice(email.indexOf('@') + 1);
  return domains.includes(emailDomain);
};

export const validateEmail = (email, emailDomains) => {
  if (!email.match(EMAIL_REGEX)) return false;
  if (emailDomains?.length > 0) return domainValidation(email, emailDomains);
  return true;
};
